module.exports = __webpack_public_path__ + "img/lifeBlock_6_en.14d84a62.png";